import { useQuery } from '@tanstack/react-query';
import * as projectsApi from '../api/projects-api';

/**
 * Hook to fetch freelancer proposal for a specific project and freelancer
 * @param projectId - The project ID
 * @param freelancerProfileId - The freelancer profile ID
 * @param enabled - Whether the query should be enabled (for lazy loading)
 */
export const useProjectFreelancerProposal = (
  projectId: number,
  freelancerProfileId: number,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['project', projectId, 'freelancer', freelancerProfileId, 'proposal'],
    queryFn: () => projectsApi.getFreelancerProposal(projectId, freelancerProfileId),
    enabled: enabled && !!projectId && !!freelancerProfileId,
    staleTime: 0,
    gcTime: 0,
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true, 
  });
};